import React, { useState, useEffect, useCallback, useContext } from 'react';
import ModalEliminacion from '../modal/ModalEliminacion';
import FilterEscaneoModal from '../modal/FilterEscaneoModal';
import { Get_use_type_name, Truncar_dispositivo, DateTime_to_string, Get_today_range } from '../Comun';
import { AuthContext } from '../contexts/AuthContext';


interface Scan 
{
    id: number;
    client_id: number;
    event_name: string;
    code: string;
    response: string;
    type_name: string;
    tag: string;
    device: string;
    accepted: boolean;
    use_type: number;
    dt_use: string;
    id_provider: number;
}

interface Client 
{
    id: number;
    name: string;
}

const Escaneos: React.FC = () => 
{
    const { token } = useContext(AuthContext);
    const [scans, setScans] = useState<Scan[]>([]);
    const [clients, setClients] = useState<Client[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [selectedScan, setSelectedScan] = useState<Scan | null>(null);
    const [isUnregisterByFilter, setUnregisterByFilter] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isFilterModalOpen, setIsFilterModalOpen] = useState<boolean>(false);    
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalResults, setTotalResults] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(0);

    const { start_dt: today_start, end_dt: today_end } = Get_today_range();
    const [filters, setFilters] = useState({
        id_client: null as number | null,
        id_event : null as number | null,
        is_root_response: false as boolean,
        response: null as string | null,
        code: null as string | null,
        type: null as number | null,
        id_tag: null as number | null,
        accepted: null as number | null,
        start_dt: today_start || null,
        end_dt: today_end || null
    });

    //-----------------------------------------------------------

    const fetchScans = useCallback(async (page: number = 1) => 
    {
      setLoading(true);
      try 
      {
          const queryParams = new URLSearchParams({
              page: page.toString(),
              ...(filters.id_client && { id_client: filters.id_client.toString() }),
              ...(filters.id_event && { id_event: filters.id_event.toString() }),
              ...(filters.code && { code: filters.code }),
              ...(filters.response && {[filters.is_root_response ? 'root_response' : 'response']: filters.response }),
              ...(filters.type !== null && { type: filters.type.toString() }),
              ...(filters.id_tag !== null && { tag: filters.id_tag.toString() }),
              ...(filters.accepted !== null && { accepted: filters.accepted.toString() }),
              ...(filters.start_dt && { start_dt: filters.start_dt }),
              ...(filters.end_dt && { end_dt: filters.end_dt }),
          });
  
          const api_url = process.env.REACT_APP_API_BASE_URL || '';
          const response = await fetch(`${api_url}web/search_registered_codes?${queryParams.toString()}`, {
              method: 'GET',
              headers: {
                  'X-AUTH-TOKEN': token || '',
              },
          });
  
          if (response.ok) 
          {
              const data = await response.json();
              setScans(data.results);
              setTotalResults(data.total_results);
              setTotalPages(data.total_pages);
              setCurrentPage(page);
          } 
          else 
          {
              throw new Error('Error al cargar eventos.');
          }
      } 
      catch (error) 
      {
          const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
          setError(errorMsg);
      } 
      finally 
      {
          setLoading(false);
      }
  }, [filters, token]);
  
//-----------------------------------------------------------

  const fetchClients = useCallback(async () => 
    {
      try 
      {
        const api_url = process.env.REACT_APP_API_BASE_URL || '';
        const response = await fetch(`${api_url}web/get_clients`, {
          method: 'GET',
          headers: {
            'X-AUTH-TOKEN': token || '',
          },
        });
  
        if (response.ok) 
        {
          const data = await response.json();
          setClients(data);
        } 
        else 
        {
          throw new Error('Error al cargar clientes.');
        }
      } 
      catch (error) 
      {
        const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
        setError(errorMsg);
      } 
    }, [token]);

    //-----------------------------------------------------------

    useEffect(() => 
    {
      const loadInitialData = async () => 
      {
          try 
          {
              await fetchClients();
          } 
          catch (error) 
          {
              setError('Error al cargar datos iniciales.');
          }
      };
  
      loadInitialData();
  }, [fetchClients]);
  

    //-----------------------------------------------------------

    useEffect(() => 
    {
        fetchScans(currentPage);
    }, [fetchScans, currentPage, filters]);

    //-----------------------------------------------------------

    const i_Unregister_selected_code = async () =>
    {
        const formData = new URLSearchParams();
        formData.append('id', selectedScan?.id.toString() || '');

        const api_url = process.env.REACT_APP_API_BASE_URL || '';
        const response = await fetch(`${api_url}web/unregister_code`, {
            method: 'POST',
            headers: {
                'X-AUTH-TOKEN': token || '',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData.toString()
        });

        if (response.ok) 
            fetchScans(1);
        else 
            throw new Error('Error al desregistar el código.');
    }

    //-----------------------------------------------------------
    
    const i_Unregister_codes_by_filter = async () =>
    {
        const queryParams = new URLSearchParams({
            ...(filters.id_client && { id_client: filters.id_client.toString() }),
            ...(filters.id_event && { id_event: filters.id_event.toString() }),
            ...(filters.code && { code: filters.code }),
            ...(filters.response && {[filters.is_root_response ? 'root_response' : 'response']: filters.response }),
            ...(filters.type !== null && { type: filters.type.toString() }),
            ...(filters.id_tag !== null && { tag: filters.id_tag.toString() }),
            ...(filters.accepted !== null && { accepted: filters.accepted.toString() }),            
            ...(filters.start_dt && { start_dt: filters.start_dt }),
            ...(filters.end_dt && { end_dt: filters.end_dt }),
        });

        const api_url = process.env.REACT_APP_API_BASE_URL || '';
        const response = await fetch(`${api_url}web/unregister_codes_by_filter?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'X-AUTH-TOKEN': token || '',
            },
        });

        if (response.ok) 
            fetchScans(1);
        else 
            throw new Error('Error al desregistar códigos.');
    }

    //-----------------------------------------------------------

    const handleConfirmUnregister = async () => 
    {
        setIsModalOpen(false);

        try
        {
            if (isUnregisterByFilter === true)
                await i_Unregister_codes_by_filter();
            else
                await i_Unregister_selected_code();
        }
        catch (error) 
        {
            const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
            setError(errorMsg);
        } 
    };

    //-----------------------------------------------------------

    const handleCancelUnregister = () => 
    {
        setIsModalOpen(false);
    };

    //-----------------------------------------------------------

    const handleUnregisterClick = (scan: Scan) => 
    {
        setUnregisterByFilter(false);
        setSelectedScan(scan);
        setIsModalOpen(true);
    };

    //-----------------------------------------------------------

    const handleFilterOpen = () => 
    {
        setIsFilterModalOpen(true);
    };

    //-----------------------------------------------------------

    const handleApplyFilters = (filters: {
        id_client: number | null;
        id_event: number | null;
        is_root_response: boolean;
        response: string | null;
        code: string | null;
        type: number | null;
        id_tag: number | null;
        accepted: number | null;
        start_dt: string | null;
        end_dt: string | null;}) => 
    {
        setFilters(filters);
        setCurrentPage(1);
    };

    //-----------------------------------------------------------

    const handleClearFilters = () =>
    {
        setFilters({
            id_client: null,
            id_event: null,
            is_root_response: false,
            response: null,
            code: null,
            type: null,
            id_tag: null,
            accepted: null,
            start_dt: null,
            end_dt: null});
        setCurrentPage(1);
    };

    //-----------------------------------------------------------

    const handlePageChange = (newPage: number) => 
    {
        if (newPage > 0 && newPage <= totalPages) 
        {
            setCurrentPage(newPage);
            //fetchScans(newPage);
        }
    };  

    //-----------------------------------------------------------

    const Get_client_name = (id: number): string => 
    {
        const client = clients.find(c => c.id === id);
        return client ? client.name : '<desconocido>';
    };

    //-----------------------------------------------------------    

    const handleUnregisterFilteredClick = () => 
    {
        setUnregisterByFilter(true);
        setIsModalOpen(true);
    };

    //-----------------------------------------------------------    

    const handleDownloadFilteredClick = async () => 
    {
        const queryParams = new URLSearchParams({
            ...(filters.id_client && { id_client: filters.id_client.toString() }),
            ...(filters.id_event && { id_event: filters.id_event.toString() }),
            ...(filters.code && { code: filters.code }),
            ...(filters.response && {[filters.is_root_response ? 'root_response' : 'response']: filters.response}),
            ...(filters.type !== null && { type: filters.type.toString() }),
            ...(filters.id_tag !== null && { tag: filters.id_tag.toString() }),
            ...(filters.accepted !== null && { accepted: filters.accepted.toString() }),
            ...(filters.start_dt && { start_dt: filters.start_dt }),
            ...(filters.end_dt && { end_dt: filters.end_dt }),
        });
    
        try 
        {
            const api_url = process.env.REACT_APP_API_BASE_URL || '';
            const response = await fetch(`${api_url}web/export_search_registered_codes?${queryParams.toString()}`, {
                method: 'GET',
                headers: {
                    'X-AUTH-TOKEN': token || '',
                },
            });
    
            if (!response.ok) 
                throw new Error('Error al descargar el archivo CSV.');
    
            // Convertir la respuesta a un Blob
            const blob = await response.blob();
            
            // Crear un enlace temporal para la descarga
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'export.csv'; // Nombre del archivo a descargar
            document.body.appendChild(a);
            a.click();
            
            // Limpiar el enlace
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } 
        catch (error) 
        {
            const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
            setError(errorMsg);
        }
    };
    
    //-----------------------------------------------------------

    const i_Message_warning_unregister = () => 
    {
        if (isUnregisterByFilter === true)
            return (<p>Los escaneos mostrados van a ser borrados</p>);
        else
            return (<p>El ÚLTIMO REGISTRO del código <b>{selectedScan?.code}</b> va a ser borrado</p>);
    }

    //-----------------------------------------------------------

    return (
        <div className="escaneos-container">
            <div className="content-wrapper">
                <div className="header">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                </td>
                                <td>
                                    <button
                                        className="filter-button"
                                        onClick={handleFilterOpen}>
                                        <i className="fas fa-filter"></i> Filtro
                                    </button>
                                    <button
                                        className="filter-button"
                                        onClick={handleDownloadFilteredClick}>
                                        <i className="fas fa-file-arrow-down"></i> Descargar filtrados
                                    </button>                                    
                                    <button
                                        className="unregister-button-wide"
                                        onClick={handleUnregisterFilteredClick}>
                                        <i className="fas fa-rotate-left"></i> Desescanear filtrados
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="eventos-container">
                    {error && <p className="error-message">{error}</p>}
                    <div className="codes-container">
                        {loading && !error && <p className="loading-message">Obteniendo escaneos...</p>}
                        {!loading && !error && scans.length === 0 && <p>No hay escaneos para mostrar.</p>}
                        {!loading && !error && scans.length > 0 && (
                            <div>
                                <table className="eventos-table">
                                    <tbody>
                                    {scans.map(scan => {
                                        const date = new Date(scan.dt_use);
                                        const formattedDateTime = DateTime_to_string(date);

                                        return (
                                            <tr key={scan.id}>
                                                <td className="evento-provider">{Get_client_name(scan.client_id)}</td>
                                                <td>{scan.event_name}</td>                                                
                                                <td className="evento-codigo">{scan.code}</td>
                                                <td className="evento-autonext">{scan.type_name}</td>
                                                <td className="evento-autonext">{scan.tag}</td>
                                                <td>{scan.response}</td>
                                                <td className="evento-autonext" title={scan.device}>{Truncar_dispositivo(scan.device)}</td>                                                
                                                <td className={scan.accepted? 'uso-verde' : 'uso-rojo'}>{Get_use_type_name(scan.use_type)}</td>
                                                <td className="evento-autonext">{formattedDateTime}</td>
                                                <td className="evento-actions">
                                                    <button className="unregister-button-widest" onClick={() => handleUnregisterClick(scan)} disabled={!scan.accepted}><i className="fas fa-rotate-left"></i>Desescanear</button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
                {!loading && scans.length > 0 && (
                <div className="pagination-controls">
                    <div className="pagination-buttons">
                        <button 
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage <= 1} >
                            <i className="fas fa-caret-left"></i>
                        </button>
                        <span>{currentPage.toLocaleString('es-ES')} / {totalPages.toLocaleString('es-ES')}</span>
                        <button 
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage >= totalPages} >
                            <i className="fas fa-caret-right"></i>
                        </button>
                    </div>
                    <div className="pagination-info">
                        <span>{totalResults.toLocaleString('es-ES')} resultados</span>
                    </div>
                </div>
                )}
            </div>

            {isModalOpen && (
                <ModalEliminacion
                    isOpen={isModalOpen}
                    onClose={handleCancelUnregister}
                    onConfirm={handleConfirmUnregister}
                >
                    {i_Message_warning_unregister()}                    
                </ModalEliminacion>
            )}

            {isFilterModalOpen && (
                <FilterEscaneoModal
                    isOpen={isFilterModalOpen}
                    onClose={() => setIsFilterModalOpen(false)}
                    onApplyFilters={handleApplyFilters}
                    onClearFilters={handleClearFilters}
                    clients={clients}
                    currentFilters={filters}
                />
            )}
        </div>
    );
};

export default Escaneos;
